import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AboutComponent } from './components/about/about.component';
import { AgentDetailComponent } from './components/agent-detail/agent-detail.component';
import { AgentListComponent } from './components/agent-list/agent-list.component';
import { AlertedListComponent } from './components/alerted-list/alerted-list.component';
import { CompanyDetailComponent } from './components/company-detail/company-detail.component';
import { CompanyListComponent } from './components/company-list/company-list.component';
import { ContentListComponent } from './components/content-list/content-list.component';
import { SearchListComponent } from './components/search-list/search-list.component';
import { SubscribePageComponent } from './components/subscribe-page/subscribe-page.component';
import { LocationStatsComponent } from './components/location-stats/location-stats.component';
import { RedirectComponent } from './components/redirect/redirect.component';
import { SeoContentComponent } from './components/seo-content/seo-content.component';
import { JobListComponent } from './components/job-list/job-list.component';
import { HomeComponent } from './components/home/home.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { IframeComponent } from './components/iframe/iframe.component';
import { TermsComponent } from './components/terms/terms.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { JobBrowserComponent } from './components/job-browser/job-browser.component';
import { JobAdvertiseComponent } from './components/job-advertise/job-advertise.component';
import { TestComponent } from './components/test/test.component';
import { AssessmentTestComponent } from './components/assessment-test/assessment-test.component';
import { AssessmentTestListComponent } from './components/assessment-test-list/assessment-test-list.component';
import { RtwadListComponent } from './components/rtwad-list/rtwad-list.component';
import { RtwadDetailComponent } from './components/rtwad-detail/rtwad-detail.component';
import { RtwadSummaryComponent } from './components/rtwad-summary/rtwad-summary.component';
import { RtwadSeekerListComponent } from './components/rtwad-seeker-list/rtwad-seeker-list.component';
import { CoreModule } from 'src/app/core/core.module';

const shared = [
  HomeComponent, JobListComponent, RedirectComponent, SeoContentComponent, LocationStatsComponent,
  SearchListComponent, AgentListComponent, AgentDetailComponent, CompanyListComponent, CompanyDetailComponent,
  AboutComponent, ContentListComponent, AlertedListComponent, SubscribePageComponent, IframeComponent,
  TermsComponent, ContactUsComponent, JobBrowserComponent, JobAdvertiseComponent, TestComponent,
  AssessmentTestComponent, AssessmentTestListComponent, RtwadListComponent,RtwadDetailComponent, RtwadSummaryComponent, RtwadSeekerListComponent
];

@NgModule({
  declarations: shared,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgSelectModule,
    TooltipModule.forRoot(),
    NgxSmartModalModule.forRoot(),
    InfiniteScrollModule,
    CoreModule,
    SharedModule
  ],
  exports: shared
})
export class WebModule { }
